module.exports = {
        srcSet: __webpack_public_path__ + "amenities_jamie_oliver_deli_by_shell-58-a05e0fa5c3876ee9.digested.jpg"+" 58w",
        images: [{path: __webpack_public_path__ + "amenities_jamie_oliver_deli_by_shell-58-a05e0fa5c3876ee9.digested.jpg",width: 58,height: 58}],
        src: __webpack_public_path__ + "amenities_jamie_oliver_deli_by_shell-58-a05e0fa5c3876ee9.digested.jpg",
        toString: function(){return __webpack_public_path__ + "amenities_jamie_oliver_deli_by_shell-58-a05e0fa5c3876ee9.digested.jpg"},
        
        width: 58,
        height: 58
      }